import { render, staticRenderFns } from "./atcd-historique-enf-personnel.html?vue&type=template&id=52e4629b&scoped=true&external"
import script from "./atcd-historique-enf-personnel.js?vue&type=script&lang=js&external"
export * from "./atcd-historique-enf-personnel.js?vue&type=script&lang=js&external"
import style0 from "./atcd-historique-enf-personnel.scss?vue&type=style&index=0&id=52e4629b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e4629b",
  null
  
)

export default component.exports